import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { IndusindBankService } from '../services/indusindbank.service';
@Component({
    selector: 'app-indusindbankaudit',
    templateUrl: './indusindbankaudit.component.html',
    styleUrls: ['./indusindbankaudit.component.css']
})
export class IndusindBankAuditComponent implements OnInit {
    displayedColumns = [
        'action',
        'isData',
        'webhook',
        'requestUUID',
        'createdAt',
    ];
    fromDate;
    toDate;
    isToggled: boolean = false;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<indusindBankData>;
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private indusindbank: IndusindBankService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }

    // onToggle() {
    //     this.isToggled = !this.isToggled;
    // }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: jsonData,
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.indusindbank.getIndusindBankAudit(this.filter).subscribe((success) => {
                let indusindBankRes = success.map(indusindBankAudit => {
                    indusindBankAudit.createdAt = moment(indusindBankAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return indusindBankAudit;
                })
                this.dataSource = new MatTableDataSource(indusindBankRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const indusindbankaudit = await this.dataSource.filteredData.map(x => ({
                "Webhook": x.webhook,
                "Is Data": x.isData,
                "requestUUID": x.requestUUID,
                "Created At": x.createdAt,
            }));
            TableUtil.exportArrayToExcel(indusindbankaudit, "indusindbankaudit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface indusindBankData {
    action: string,
    isData: string,
    webhook: string,
    requestUUID: string,
    createdAt: string,
}


// WEBPACK FOOTER //
// ./src/app/indusindbankaudit/indusindbankaudit.component.ts